// Angular
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    inject,
} from '@angular/core';

// Ngrx
import { Store } from '@ngrx/store';

// Models
import { Product } from '../../../shared/models/b2b/product';
import { Stock } from '../../../shared/models/b2b/stock';
import { AppState } from '../../../store';

// Helpers
import * as moment from 'moment';
import { SoledadUserService } from 'app/shared/services/b2b/user.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-product-stock',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-stock.component.html',
})
export class ProductStockComponent implements OnChanges, OnDestroy {
    item: Product;
    productStock: Stock[] = [];

    @Input() options: any;
    empresa: number;
    isComercial = false;

    today: string = moment().format('YYYY-MM-DD');
    loading = true;

    private userSubscription: Subscription;

    userService = inject(SoledadUserService);
    private store = inject(Store<AppState>);
    private cdr = inject(ChangeDetectorRef);

    constructor() {
        this.userSubscription = this.store.select((state) => state.user.data.tipoUsuario).subscribe((tipoUsuario) => {
            this.isComercial = tipoUsuario === 'COMERCIAL';
            this.cdr.markForCheck();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.options && changes.options.currentValue) {
            this.options = changes.options.currentValue;
            this.initModalOptions(this.options);
        }
    }

    initModalOptions(options: {}): void {
        this.item = options['itemProduct'];
        this.empresa = options['empresa'];
        if (options['productStock']) {
            this.productStock = options['productStock'];
            this.loading = false;
        }
    }

    ngOnDestroy(): void {
        this.userSubscription?.unsubscribe();
    }

    isToday(date: string): boolean {
        return date === 'Hoy' || date === "Aujourd'hui" || date === 'Hoje';
    }

    isTomorrow(date: string): boolean {
        return date === 'Mañana' || date === 'Demain' || date === 'Manhã';
    }

    getDateFormated(date: string): string {
        const ret = moment(date).format('DD MMM').toString();
        return ret;
    }
}
